import { HiverAxios, setHiddenLoadingBar, getIntegersParsedObject } from 'h-commons'
import { 
    GET_ROLES_DONE, GET_ROLES_FAILED, GET_ROLES_INIT, 
    ADD_ROLE_DONE, ADD_ROLE_FAILED, ADD_ROLE_INIT,
    UPDATE_ROLE_DONE, UPDATE_ROLE_FAILED, UPDATE_ROLE_INIT, 
    SET_CURRENT_ROLE, UNSET_CURRENT_ROLE, SET_CURRENT_ROLE_DATA,
    RESET_CURRENT_ROLE_DATA, DELETE_ROLE_DONE, DELETE_ROLE_FAILED, DELETE_ROLE_INIT,
    CHANGE_USER_ROLE_DONE, CHANGE_USER_ROLE_FAILED, CHANGE_USER_ROLE_INIT,
    SET_CURRENT_ROLE_PERMISSION, SET_CURRENT_ROLE_META
 } from './types'

import pick from 'lodash/pick'
import { showMessage, sendTrackingEvent } from 'h-commons'
import { getChangesForRoles } from '../rolesUtils'
export const setCurrentRole = (roleId) => ({
    type: SET_CURRENT_ROLE,
    payload: roleId
})

export const setCurrentRolePermission = (value, code) => ({
    type: SET_CURRENT_ROLE_PERMISSION,
    payload: { value, code }
})

export const setCurrentRoleMeta = (target, value) => ({
    type: SET_CURRENT_ROLE_META,
    payload: { target, value }
})

export const unsetCurrentRole = () => ({
    type: UNSET_CURRENT_ROLE
})

export const setCurrentRoleData = (payload) => ({
    type: SET_CURRENT_ROLE_DATA,
    payload
})

export const resetCurrentRoleData = () => ({
    type: RESET_CURRENT_ROLE_DATA
})

const RESOURCE_URL = '/api/rolesandpermissions'

export const getRoles = (rolesExist, isTest) => (dispatch) => {
    rolesExist && dispatch(setHiddenLoadingBar(true))
    dispatch({ 
        type: GET_ROLES_INIT
    })
    return HiverAxios({
        url: RESOURCE_URL,
        type: 'GET',
        callback(resp){
            const response = resp.data;
            response.forEach((item) => {
                item.defaultrole = `${item.defaultrole}`
            })
            dispatch({ 
                type: GET_ROLES_DONE,
                payload: getIntegersParsedObject(response)
            })
            dispatch(setHiddenLoadingBar(false))
        },
        onfail(err) {
            dispatch({
                type: GET_ROLES_FAILED,
                payload: err
            })
            dispatch(setHiddenLoadingBar(false))
        }
    }, isTest)
}

export const addRole = (params, cb) => dispatch => {
    dispatch({
        type: ADD_ROLE_INIT
    })
    return HiverAxios({
        url: RESOURCE_URL,
        type: 'POST',
        params: pick(params, ['name', 'description', 'permissions']),
        callback: (resp) => {
            const response = resp.data
            if (response.success)  {
                dispatch({
                    type: ADD_ROLE_DONE,
                    payload: { id: response.id, ...params }
                })
                showMessage({ 
                    message: `Role ${params.name} was created successfully`,
                    type: 'success'
                })
                sendTrackingEvent('createdCustomRole',{roleName: params.name});
                cb(response.id)
            } else {
                dispatch({
                    type: ADD_ROLE_FAILED
                })    
                showMessage({
                    message: response.message || `Failed to create new role ${params.name}`,
                    type: 'error'
                })
            }
        }, 
        onfail: (err) => {
            dispatch({
                type: ADD_ROLE_FAILED,
                payload: err
            })
            showMessage({
                message: `Failed to create new role ${params.name}`,
                type: 'error'
            })
        }
    })
}

export const updateRole = (roleId, params, permissionState) => (dispatch) => {
    dispatch({
        type: UPDATE_ROLE_INIT
    })

    return HiverAxios({
        url: `${RESOURCE_URL}/${roleId}`,
        type: 'PUT',
        params: pick(params, ['id', 'name', 'description', 'permissions']),
        callback: (resp) => {
            const response = resp.data
            if (response.success) {
                dispatch({
                    type: UPDATE_ROLE_DONE,
                    payload: params
                })
                dispatch({
                    type: SET_CURRENT_ROLE_DATA,
                    payload: {
                        name: params.name,
                        description: params.description,
                        permissions: permissionState
                    }
                })
                showMessage({ 
                    message: `Role ${params.name} was updated successfully`,
                    type: 'success'
                })
            } else {
                dispatch({
                    type: UPDATE_ROLE_FAILED
                })
                showMessage({
                    message: response.message || `Failed to update role ${params.name}`,
                    type: 'error'
                })    
            }
        }, 
        onfail: (err) => {
            dispatch({
                type: UPDATE_ROLE_FAILED,
                payload: err
            })
            showMessage({
                message: `Failed to update role ${params.name}`,
                type: 'error'
            })
        }
    })
}

export const deleteRole = (roleId, roleName, targetUsers) => (dispatch, getState) => {
    dispatch({
        type: DELETE_ROLE_INIT
    })
    HiverAxios({
        url: `${RESOURCE_URL}/${roleId}`,
        type: 'DELETE',
        callback: (resp) => {
            const response = resp.data
            if (response.success) {
                dispatch({
                    type: DELETE_ROLE_DONE,
                    payload: roleId
                });
                showMessage({ 
                    message: `Role "${roleName}" was deleted successfully`,
                    type: 'success'
                });
                if (targetUsers && targetUsers.length) {
                    const { usersAndGroups, roles } = getState()
                    const { users } = usersAndGroups;
                    const memberRoleId = Object.keys(roles.data.byId).find(id => {
                        return roles.data.byId[id].name === 'Member'
                    });
                    const changes = getChangesForRoles(users, memberRoleId, targetUsers);
                    const payload = changes.reduce((prev, current) => {
                        return { ...prev, [current.userId]: current.roleId }
                    }, {})
                    dispatch({
                        type: CHANGE_USER_ROLE_DONE,
                        payload,
                        role: roles.data.byId[memberRoleId]
                    })
                }
            } else {
                dispatch({
                    type: DELETE_ROLE_FAILED
                })
                showMessage({ 
                    message: response.message || `Failed to delete role #${roleId}`,
                    type: 'error'
                })
            }
            sendTrackingEvent('deletedCustomRole',{roleName});
        }, 
        onfail: (err) => {
            dispatch({
                type: DELETE_ROLE_FAILED,
                payload: err
            })
            showMessage({ 
                message: `Failed to delete role #${roleId}`,
                type: 'error'
            })
        }
    })
}

export const addUsersToRole = (role, changes) => dispatch => {
    dispatch({
        type: CHANGE_USER_ROLE_INIT
    })
    HiverAxios({
        url: '/api/settings/users/changerole',
        type: 'POST',
        params: {
            rolesUserids: changes
        },
        callback: (resp) => {
            const response = resp.data
            const plural = changes.length > 1? 's':''
            if (response && response.success) {
                const payload = changes.reduce((prev, current) => {
                    return { ...prev, [current.userId]: current.roleId }
                }, {})
                dispatch({
                    type: CHANGE_USER_ROLE_DONE,
                    payload,
                    role
                })
                showMessage({
                    message: `User${plural} added to role successfully`,
                    type: 'success'
                })
                const eventName = role.default ? 'addedDefaultRole' : 'addedCustomRole';
                sendTrackingEvent(eventName,{roleName:role.name});
            } else {
                dispatch({
                    type: CHANGE_USER_ROLE_FAILED
                })
                showMessage({
                    message: response.message || `Failed to change role for user${plural}`,
                    type: 'error'
                })
            }
        },
        onfail: err => {
            dispatch({
                type: CHANGE_USER_ROLE_FAILED,
                payload: err
            })
            showMessage({
                message: 'Failed to change role for user(s)',
                type: 'error'
            })
        }
    });
}
